import {
  Box,
  Container,
  Divider,
  Grid,
  ListItem,
  ListItemIcon,
  ListItemText,
  Stack,
  Typography,
  useTheme
} from "@mui/material"

import Image from "next/image"
import Link from "next/link"
import { Link as ScrollLink } from "react-scroll"

import { Location, Send as Mail, Message, Mobile, Printer } from "iconsax-react"
import IcsLogo from "public/images/ics24-logo-primary.svg"
import Mellat from "public/images/MellatBank.png"
import Shaghayegh from "public/images/Shaghayegh.svg"
import sls from "public/images/sls.png"
import BasicLogo from "../../../../common/BasicLogo"
import MainCard from "../../../../common/main-card"
import Pages from "src/constants/pages"

const LandingFooter = () => {
  // Use Theme
  const theme = useTheme()

  // service
  const services = [
    { title: "ثبت نام", href: "/register", page: true },
    { title: "ورود", href: "/login", page: true },
    { title: "ماشین حساب", href: "calculator" },
    { title: "تراکنش ها", href: Pages.Transactions, page: true },
    { title: "دریافت وام", href: Pages.Facilities, page: true },
    { title: "پرداخت اقساط", href: "/payInstallment/0", page: true },
    { title: "درخواست پذیرندگی", href: "/merchant/request", page: true },
    { title: "درخواست تسهیلات سازمانی", href: Pages.GroupFacilities, page: true }
  ]

  const accessList = [
    { title: "صفحه اصلی", href: Pages.Main, page: true },
    { title: "سایت مهندسی نرم افزار شقایق", href: "https://shsoftco.com", page: true }
  ]

  const about = [
    { title: "تماس با ما", href: "#" },
    { title: "اخبار و اطلاعیه ها", href: "#" },
    { title: "درباره ما", href: "#" }
  ]

  const popupOptions =
    "toolbar=no, scrollbars=no, location=no, statusbar=no, menubar=no, resizable=0, width=450, height=630, top=30"

  return (
    <>
      <Box
        sx={{
          background: theme.palette.background.paper,
          mb: -1,
          height: 100,
          clipPath:
            "polygon(100% 100%, 0% 100% , 0.00% 73.77%, 2.00% 75.90%, 4.00% 77.69%, 6.00% 79.10%, 8.00% 80.13%, 10.00% 80.77%, 12.00% 81.00%, 14.00% 80.83%, 16.00% 80.25%, 18.00% 79.28%, 20.00% 77.93%, 22.00% 76.20%, 24.00% 74.11%, 26.00% 71.70%, 28.00% 68.97%, 30.00% 65.96%, 32.00% 62.69%, 34.00% 59.21%, 36.00% 55.54%, 38.00% 51.73%, 40.00% 47.81%, 42.00% 43.82%, 44.00% 39.80%, 46.00% 35.79%, 48.00% 31.84%, 50.00% 27.98%, 52.00% 24.25%, 54.00% 20.69%, 56.00% 17.33%, 58.00% 14.21%, 60.00% 11.37%, 62.00% 8.82%, 64.00% 6.60%, 66.00% 4.72%, 68.00% 3.22%, 70.00% 2.09%, 72.00% 1.36%, 74.00% 1.02%, 76.00% 1.09%, 78.00% 1.56%, 80.00% 2.44%, 82.00% 3.70%, 84.00% 5.33%, 86.00% 7.33%, 88.00% 9.67%, 90.00% 12.32%, 92.00% 15.27%, 94.00% 18.47%, 96.00% 21.90%, 98.00% 25.53%, 100.00% 29.31%)"
        }}
      ></Box>
      <Box
        sx={{
          backgroundColor: theme.palette.background.paper
        }}
      >
        <Container sx={{ p: 5 }}>
          <Grid container sx={{ mt: 2 }}>
            <Grid item md={3}>
              <Stack justifyContent='flex-start' alignItems={"center"} sx={{ cursor: "pointer" }}>
                <BasicLogo height={80} />
                {/* <Image src={Shaghayegh} alt='جت وام' width={180} /> */}
                <Stack direction="row" alignItems={"center"}>
                  <Image src={sls} alt='راهکار سرزمین هوشمند' width={100} />
                  <Image src={Shaghayegh} alt='جت وام' width={180} />
                </Stack>
              </Stack>
              <Box sx={{ mt: 2 }}>
                <Typography variant='subtitle2' sx={{ textAlign: "justify" }}>
                  با جت وام هرجایی که هستی فقط کافیه به اینترنت متصل باشی و با چک صیادی و بدون دردسر و خیلی سریع وام
                  بگیری.
                </Typography>
                <Grid display={"flex"} alignItems={"center"} gap={1.5} justifyContent={"flex-start"} flexWrap='wrap'>
                  <Grid
                    mt={"15px"}
                    display='flex'
                    alignItems={"center"}
                    justifyContent={"flex-start"}
                    border={"1px solid #e0e0e6"}
                    borderRadius={"8px"}
                    p={"10px"}
                  >
                    <a
                      referrerPolicy='origin'
                      target='_blank'
                      href='https://trustseal.enamad.ir/?id=345190&amp;Code=M437MprMOKoxcUmyXdiY'
                      style={{ height: "75px" }}
                    >
                      <img
                        src={`https://Trustseal.eNamad.ir/logo.aspx?id=345190&Code=M437MprMOKoxcUmyXdiY`}
                        width={"75px"}
                        height={"75px"}
                      />
                    </a>
                  </Grid>
                  <Grid
                    mt={"15px"}
                    display='flex'
                    alignItems={"center"}
                    justifyContent={"flex-start"}
                    border={"1px solid #e0e0e6"}
                    borderRadius={"8px"}
                    style={{ cursor: "pointer" }}
                    p={"10px"}
                    onClick={() =>
                      window.open(
                        "https://logo.samandehi.ir/Verify.aspx?id=360767&p=xlaogvkaobpdjyoegvkajyoe",
                        "Popup",
                        popupOptions
                      )
                    }
                  >
                    <img
                      referrerPolicy='origin'
                      id='rgvjfukzesgtjzpefukzjzpe'
                      alt='logo-samandehi'
                      src='https://logo.samandehi.ir/logo.aspx?id=360767&p=qftiwlbqlymayndtwlbqyndt'
                      width={"75px"}
                      height={"75px"}
                    />
                  </Grid>
                  <Grid
                    mt={"15px"}
                    display='flex'
                    alignItems={"center"}
                    justifyContent={"center"}
                    border={"1px solid #e0e0e6"}
                    borderRadius={"8px"}
                    p={"10px"}
                    width={"100px"}
                    height={"96px"}
                    sx={{ cursor: "pointer" }}
                  >
                    <Image src={Mellat} alt='لوگو بانک ملت' width={100} />
                  </Grid>
                  <Grid
                    mt={"15px"}
                    display='flex'
                    flexDirection='column'
                    alignItems={"center"}
                    justifyContent={"center"}
                    border={"1px solid #e0e0e6"}
                    borderRadius={"8px"}
                    p={"10px"}
                    gap={0.5}
                  >
                    <Image src={IcsLogo} alt='شرکت اعتبار سنجی ایران' width={140} height={24} />
                    <Typography variant='caption' textAlign='center' lineHeight={1.4} fontSize={11}>
                      شرکت اعتبار سنجی ایران
                    </Typography>
                  </Grid>
                </Grid>
              </Box>
            </Grid>
            <Grid item xs={3}>
              <Stack direction='row' justifyContent='center'>
                <Box>
                  <Typography fontWeight='bold' sx={{ color: theme.palette.mode === "dark" ? "#fff" : "#000000" }}>
                    خدمات
                  </Typography>
                  <Stack spacing={2} mt={4} sx={{ textAlign: "start" }}>
                    {services?.map((item, index) => (
                      <Typography
                        to={item.href}
                        component={item.page ? Link : ScrollLink}
                        key={index}
                        href={item.href}
                        target={item.page ? "_blank" : ""}
                        variant='caption'
                      >
                        {item?.title}
                      </Typography>
                    ))}
                  </Stack>
                </Box>
              </Stack>
            </Grid>
            <Grid item xs={3}>
              <Stack direction='row' justifyContent='center'>
                <Box>
                  <Typography fontWeight='bold' sx={{ color: theme.palette.mode === "dark" ? "#fff" : "#000000" }}>
                    دسترسی ها
                  </Typography>
                  <Stack spacing={2} mt={4} sx={{ textAlign: "start" }}>
                    {accessList?.map((item, index) => (
                      <Typography
                        to={item.href}
                        component={item.page ? Link : ScrollLink}
                        key={index}
                        href={item.href}
                        target={item.page ? "_blank" : ""}
                        variant='caption'
                      >
                        {item?.title}
                      </Typography>
                    ))}
                  </Stack>
                </Box>
              </Stack>
            </Grid>
            {/* <Grid item xs={3}>
              <Stack direction='row' justifyContent='center'>
                <Box>
                  <Typography fontWeight='bold' sx={{ color: theme.palette.mode === "dark" ? "#fff" : "#000000" }}>
                    درباره
                  </Typography>
                  <Stack spacing={2} mt={4} sx={{ textAlign: "start" }}>
                    {about?.map((item, index) => (
                      <Typography
                        to={item.href}
                        component={item.page ? Link : ScrollLink}
                        key={index}
                        href={item.href}
                        target={item.page ? "_blank" : ""}
                        variant='caption'
                      >
                        {item?.title}
                      </Typography>
                    ))}
                  </Stack>
                </Box>
              </Stack>
            </Grid> */}
          </Grid>

          <Divider sx={{ my: 3, borderStyle: "dashed" }} />

          <MainCard
            shadow={0}
            sx={{
              borderRadius: "15px",
              background: theme.palette.background.default,
              backdropFilter: "blur(0px)",
              px: 4,
              py: 1
            }}
          >
            <Grid container>
              <Grid item xs={12} md={6}>
                <ListItem sx={{ px: 0 }}>
                  <ListItemIcon>
                    <Mobile color={theme.palette.primary.main} />
                  </ListItemIcon>
                  <ListItemText
                    primary={<Typography>تلفن</Typography>}
                    secondary={<Typography color={theme.palette.mode === "dark" ? "#fff" : "#000000"}>1658</Typography>}
                  />
                </ListItem>
                {/* <ListItem sx={{ px: 0,paddingTop:'0px',paddingBottom:'0px' }}>
                  <ListItemIcon>
                    <Mobile color={theme.palette.primary.main} />
                  </ListItemIcon>
                  <ListItemText
                    primary={<Typography>تلفن</Typography>}
                    secondary={<Typography sx={{color:'#a94354'}}>پشتیبانی متقاضیان</Typography>}
                  />
                  
                </ListItem> */}

                {/* <ListItem sx={{marginLeft:'2rem',paddingTop:'0px',paddingBottom:'0px'}}>
                  <ListItemText
                      primary={
                        <Typography color={theme.palette.mode === "dark" ? "#fff" : "#000000"}>
                          021-42067385
                        </Typography>
                  }
                    />
                </ListItem> */}
                {/* <ListItem sx={{marginLeft:'2rem',paddingTop:'0px',paddingBottom:'0px'}}>
                <ListItemText 
                    primary={
                      <Typography color={theme.palette.mode === "dark" ? "#fff" : "#000000"}>
                        021-42067456
                      </Typography>
                  }
                  />
                </ListItem>
                <ListItem sx={{marginLeft:'2rem',paddingTop:'0px',paddingBottom:'0px'}}>
                <ListItemText 
                    primary={
                      <Typography color={theme.palette.mode === "dark" ? "#fff" : "#000000"}>
                        021-42067378
                      </Typography>
                  }
                  />
                </ListItem>
                <ListItem sx={{marginLeft:'2rem',paddingTop:'0px',paddingBottom:'0px'}}>
                <ListItemText 
                    primary={
                      <Typography color={theme.palette.mode === "dark" ? "#fff" : "#000000"}>
                        021-42067383
                      </Typography>
                  }
                  />
                </ListItem> */}

                {/* <ListItem sx={{ px: 0,paddingTop:'0px',paddingBottom:'0px',marginLeft:'3.5rem' }}>
                  
                  <ListItemText
                  primary={<Typography>{' '}</Typography>}
                    secondary={<Typography sx={{color:'#a94354'}}> امور پذیرندگان</Typography>}
                  />
                  
                </ListItem>
                <ListItem sx={{marginLeft:'2rem',paddingTop:'0px',paddingBottom:'0px'}}>
                <ListItemText
                    primary={
                      <Typography color={theme.palette.mode === "dark" ? "#fff" : "#000000"}>
                        021-42067777
                      </Typography>
                         }
                    
                  />
                </ListItem> */}
              </Grid>
              <Grid item xs={12} md={6}>
                <ListItem sx={{ px: 0 }}>
                  <ListItemIcon>
                    <Printer color={theme.palette.primary.main} />
                  </ListItemIcon>
                  <ListItemText
                    primary={<Typography>فکس</Typography>}
                    secondary={
                      <Typography color={theme.palette.mode === "dark" ? "#fff" : "#000000"}>02188499648</Typography>
                    }
                  />
                </ListItem>
              </Grid>
              <Grid item xs={12} md={6}>
                <ListItem sx={{ px: 0 }}>
                  <ListItemIcon>
                    <Message color={theme.palette.primary.main} />
                  </ListItemIcon>
                  <ListItemText
                    primary={<Typography>کد پستی</Typography>}
                    secondary={
                      <Typography color={theme.palette.mode === "dark" ? "#fff" : "#000000"}>1415874611</Typography>
                    }
                  />
                </ListItem>
              </Grid>

              <Grid item xs={12} md={6}>
                <ListItem sx={{ px: 0 }}>
                  <ListItemIcon>
                    <Mail color={theme.palette.primary.main} />
                  </ListItemIcon>
                  <ListItemText
                    primary={<Typography>ایمیل</Typography>}
                    secondary={
                      <Typography color={theme.palette.mode === "dark" ? "#fff" : "#000000"}>Info@jetvam.ir</Typography>
                    }
                  />
                </ListItem>
              </Grid>

              <Grid item xs={12} md={6}>
                <ListItem sx={{ px: 0 }}>
                  <ListItemIcon>
                    <Location color={theme.palette.primary.main} />
                  </ListItemIcon>
                  <ListItemText
                    primary={<Typography>آدرس</Typography>}
                    secondary={
                      <Typography color={theme.palette.mode === "dark" ? "#fff" : "#000000"}>
                        تهران، خیابان ولیعصر، بالاتر از تقاطع زرتشت، کوچه نوربخش، پلاک 16
                      </Typography>
                    }
                  />
                </ListItem>
              </Grid>
            </Grid>
          </MainCard>

          <Divider sx={{ my: 3, borderStyle: "dashed" }} />

          <Stack spacing={2}>
            <Stack direction='row' justifyContent='space-between' alignItems='center'>
              {/* <Stack direction='row' alignItems='center' spacing={3}>
                <Image src={Instagram} alt='instagram' width={25} />
                <Image src={Telegram} alt='telegram' width={25} />
                <Image src={WhatsApp} alt='whatsapp' width={25} />
              </Stack> */}
              <Stack direction='row' alignItems='center' spacing={3}>
                {/* <Typography variant='caption' component={Link} href='/privacy'>
                  حریم خصوصی
                </Typography> */}
                {/* <Divider orientation='vertical' variant='middle' flexItem /> */}
                <Typography variant='caption' component={Link} href={Pages.LoanGuide}>
                  راهنمای دریافت وام
                </Typography>
                <Divider orientation='vertical' variant='middle' flexItem />
                <Typography variant='caption' component={Link} href='/rules'>
                  قوانین و مقررات
                </Typography>
                {/* <Divider orientation='vertical' variant='middle' flexItem /> */}
                {/* <Typography variant='caption' component={Link} href='/termsOfUse'>
                  شرایط استفاده
                </Typography> */}
                <Divider orientation='vertical' variant='middle' flexItem />
                <Typography variant='caption'>Copyright © 2023 jet vam</Typography>
              </Stack>
            </Stack>
          </Stack>
        </Container>
      </Box>
    </>
  )
}

export default LandingFooter
